import React from 'react';
import { View, Text, Image, StyleSheet, TouchableOpacity, TextInput } from 'react-native';

interface ContainerItemProps {
    description: string;
    image: string;
    qtContainers: number;
    sku: string;
    selected?: boolean;
    handleSelectProduct?: () => void; 
    renderQuantityInput?: (unitName: string) => JSX.Element;
    unitName?: string;
}

const ContainerItem: React.FC<ContainerItemProps> = ({ description, image, qtContainers, sku, handleSelectProduct, selected, renderQuantityInput, unitName }) => {
    return (
        <TouchableOpacity disabled={!handleSelectProduct} style={[styles.container, selected && styles.selectedContainer]} onPress={handleSelectProduct}>
            <Image source={{ uri: image }} style={styles.image} />
            <View style={styles.info}>
                <Text style={styles.description}>{description}</Text>
                {/* <Text style={styles.details}>SKU: {sku}</Text> */}
                {/* <Text style={styles.details}>Quantity: {qtContainers}</Text> */}
                {renderQuantityInput && renderQuantityInput(unitName)}
            </View>
        </TouchableOpacity>
    );
};

const styles = StyleSheet.create({
    container: {
        flexDirection: 'row',
        padding: 10,
        marginVertical: 5,
        backgroundColor: '#fff',
        borderRadius: 5,
        shadowColor: '#000',
        shadowOffset: { width: 0, height: 2 },
        shadowOpacity: 0.1,
        shadowRadius: 5,
        elevation: 2,
    },
    selectedContainer: {
        borderColor: 'red',
        borderWidth: 2,
    },
    image: {
        width: 60,
        height: 60,
        borderRadius: 5,
    },
    info: {
        marginLeft: 10,
        justifyContent: 'center',
    },
    description: {
        color: 'black',
        fontSize: 16,
        fontWeight: 'bold',
    },
    details: {
        fontSize: 14,
        color: '#666',
    },

});

export default ContainerItem;